'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTheme } from 'next-themes';
import type { Outfit } from '@/types/closet';
import { RotationScrubber } from './RotationScrubber';

/** Candidate review uses only the isolated still and its orbit. */
export function OutfitGallery(t0) {
  const $ = _c(4);
  const {
    outfit
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const media = outfit.lookbookMedia;
  const image = media?.imageUrl || outfit.imageUrl;
  const rotation = resolvedTheme === "dark" ? media?.rotationUrlDark : media?.rotationUrl;
  if (!image) {
    return null;
  }
  let t1;
  if ($[0] !== image || $[1] !== outfit.name || $[2] !== rotation) {
    t1 = <div className="lookbook-gallery">{rotation ? <RotationScrubber src={rotation} poster={image} name={outfit.name} /> : <Image unoptimized={true} src={image} alt={outfit.name} fill={true} sizes="50vw" className="object-contain" draggable={false} />}</div>;
    $[0] = image;
    $[1] = outfit.name;
    $[2] = rotation;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}